<template>
    <div>
        <div class="modal-button">
            <el-button size="mini" @click="openDialog()">
                Изменить
            </el-button>
        </div>
        <el-dialog title="Изменение контакта" :visible.sync="dialogTableVisible">
            <el-form :model="formEdit" :rules="rules" ref="formEdit" label-position="left" label-width="165px">
                <el-form-item label="Должность (служба)" prop="position">
                    <el-input v-model="formEdit.position"></el-input>
                </el-form-item>
                <el-form-item label="ФИО" prop="contactName">
                    <el-input v-model="formEdit.contactName"></el-input>
                </el-form-item>
                <el-form-item label="Телефон" prop="phone">
                    <el-input v-model="formEdit.phone" v-mask="'+7 ### ### ## ##'"></el-input>
                </el-form-item>
                <el-form-item label="Комментарий" prop="description">
                    <el-input v-model="formEdit.description"></el-input>
                </el-form-item>
                <el-form-item label=" Часы приема" prop="receptionHours">
                    <el-input v-model="formEdit.receptionHours"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">

                <el-button size="mini" @click="dialogTableVisible = false">
                    Отменить
                </el-button>

                <el-button size="mini" type="primary" @click="orgCreateContact" :loading="loading">
                    Сохранить
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            dialogTableVisible: false,
            formEdit: {
                id: 0,
                position: '',
                contactName: '',
                phone: '+7',
                description: '',
                receptionHours: ''
            },
            rules: {
                position: [
                    { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
                ],
                contactName: [
                    { message: 'Поле не должно быть пустым', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
                ],
            }
        }
    },
    props: {
        contact: {
            default() {
                return {}
            },
            type: Object
        },
        index: {
            default: 0,
            type: Number
        }
    },
    methods: {
        openDialog() {
            this.formEdit.id = this.contact.id
            this.formEdit.position = this.contact.position
            this.formEdit.contactName = this.contact.contactName
            this.formEdit.phone = this.contact.phone
            this.formEdit.description = this.contact.description
            this.formEdit.receptionHours = this.contact.receptionHours
            this.dialogTableVisible = true
        },
        async orgCreateContact() {

            this.$refs.formEdit.validate(async (valid) => {
                if (valid) {
                    this.loading = true
                    try {
                        await this.$store.dispatch('organizationUpdateOrCreateContact', {
                            index: this.index,
                            form: this.formEdit,
                            edit: true
                        })
                        this.dialogTableVisible = false

                    } catch (e) {
                        this.$ErrorsMod(e)
                    }
                    this.loading = false
                } else {
                    return false;
                }
            })


        }
    }
}
</script>

